import apiTrainers from '@/api/trainers'
import {propOr, uniq} from 'ramda'

const state = {
  data: [],
  isLoading: false,
  error: null,
}

export const mutationTypes = {
  getTrainersStart: '[trainers group filter] Get trainers group start',
  getTrainersSuccess: '[trainers group filter] Get trainers group success',
  getTrainersFailure: '[trainers group filter] Get trainers group failure',

  getTrainersIdsStart: '[trainers group filter] Get trainers group ids start',
  getTrainersIdsSuccess:
    '[trainers group filter] Get trainers group ids success',
  getTrainersIdsFailure:
    '[trainers group filter] Get trainers group ids failure',
}

export const actionTypes = {
  getTrainers: '[trainers group filter] Get trainers group',
  getTrainersIds: '[trainers group filter] Get trainers ids group',
}

const mutations = {
  [mutationTypes.getTrainersStart](state) {
    state.isLoading = true
    state.data = []
  },

  [mutationTypes.getTrainersSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getTrainersFailure](state) {
    state.isLoading = false
  },

  [mutationTypes.getTrainersIdsStart](state) {
    state.isLoading = true
    state.data = []
  },

  [mutationTypes.getTrainersIdsSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getTrainersIdsFailure](state) {
    state.isLoading = false
  },
}

const actions = {
  [actionTypes.getTrainers](context, data) {
    const params = propOr(null, 'params', data)
    context.commit(mutationTypes.getTrainersStart)
    return new Promise((resolve) => {
      apiTrainers
        .getTrainersList(params)
        .then((response) => {
          context.commit(mutationTypes.getTrainersSuccess, response.data.list)
          resolve(response.data.list)
        })
        .catch(() => {
          context.commit(mutationTypes.getTrainersFailure)
        })
    })
  },

  [actionTypes.getTrainersIds](context, data) {
    const params = propOr(null, 'params', data)
    const groupIds = propOr(null, 'ids', data)

    context.commit(mutationTypes.getTrainersIdsStart)

    return new Promise((resolve) => {
      const getTrainers = async (ids) => {
        let result = []
        for (const groupId of ids) {
          await context
            .dispatch(actionTypes.getTrainers, {
              params: {...params, groupId},
            })
            .then((res) => (result = uniq([...result, ...res])))
        }

        return result
      }

      getTrainers(groupIds)
        .then((response) => {
          context.commit(mutationTypes.getTrainersIdsSuccess, response)
          resolve(response)
        })
        .catch((resolve) => {
          context.commit(mutationTypes.getTrainersIdsFailure, resolve)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
